import { Link } from '@mui/material';
import { Loading } from 'components/Loading';
import { useQuery } from 'services/api/hooks';
import { getCampaign } from 'services/campaign/api';
import { Campaign } from 'services/campaign/types';
import { Paths } from 'services/navigation/paths';

type Props = {
  campaignId: string | undefined | null;
};

export const LinkedCampaign: React.FC<Props> = ({ campaignId }) => {
  const { data: campaign, isLoading } = useQuery<Campaign>(getCampaign, {
    id: campaignId
  });

  if (!campaignId) return <>-</>;

  if (isLoading) return <Loading size={12} />;

  return (
    <Link
      href={`${Paths.OUTBOUND_CAMPAIGN}/${campaignId}`}
      target="_blank"
      rel="noreferrer"
    >
      {campaign?.title || campaign?.id}
    </Link>
  );
};
